import { atom } from 'jotai';

export const demoModeAtom = atom(false);
